<div class="qr-generator">
  <!-- QR Code Canvas -->
  <div class="qr-canvas-container">
    <canvas #qrCanvas [style.display]="qrCodeGenerated ? 'block' : 'none'" class="qr-canvas"> </canvas>

    <!-- Loading state -->
    @if (!qrCodeGenerated && !errorMessage) {
      <div class="qr-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Generating QR Code...</span>
      </div>
    }
    <!-- Error state -->
    @if (errorMessage) {
      <div class="qr-error">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ errorMessage }}</span>
      </div>
    }
  </div>

  <!-- Action Buttons -->
  @if (qrCodeGenerated) {
    <div class="qr-actions mt-3 d-flex gap-2 justify-content-center">
      <button type="button" class="btn btn-primary btn-sm" (click)="downloadQR()" title="Download QR Code">
        <i class="bi bi-download me-1"></i>
        Download
      </button>
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        [class.btn-success]="copySuccess"
        [class.btn-outline-secondary]="!copySuccess"
        (click)="copyToClipboard()"
        [title]="copySuccess ? 'Copied to Clipboard!' : 'Copy QR Code to Clipboard'"
        [disabled]="copySuccess"
      >
        <i [class]="copySuccess ? 'bi bi-check me-1' : 'bi bi-copy me-1'"></i>
        {{ copySuccess ? 'Copied!' : 'Copy' }}
      </button>
    </div>
  }
</div>
